// Décisions du bandeau d'installation de l'app Android, isolées du controller
// Stimulus pour être testables sans DOM (spec/javascript/android_app_banner.test.js).

export const DISMISS_KEY = "_androidAppBannerDismissedAt"
export const DISMISS_TTL = 30 * 24 * 60 * 60 * 1000 // 30 jours

// `localStorage` / `sessionStorage` lèvent une `SecurityError` — parfois dès
// l'accès à la propriété — quand le stockage est bloqué : Chrome « bloquer tous
// les cookies », WebViews embarquées, mode restreint de certains navigateurs.
// Aucune des mémoires posées ici ne vaut de faire tomber le bandeau ou son
// bouton de fermeture : on dégrade en « pas de mémoire », jamais en exception.
export function readStorage(area, key) {
  try {
    return globalThis[area].getItem(key)
  } catch {
    return null
  }
}

export function writeStorage(area, key, value) {
  try {
    globalThis[area].setItem(key, value)
    return true
  } catch {
    // Stockage indisponible : le choix ne sera pas mémorisé, rien de plus.
    return false
  }
}

export function removeStorage(area, key) {
  try {
    globalThis[area].removeItem(key)
  } catch {
    // Stockage indisponible : rien à nettoyer, sans conséquence.
  }
}

// `raw` est la valeur brute relue du stockage (donc `null` si absente ou
// illisible). Une horloge remise en arrière rendrait l'horodatage futur et
// masquerait le bandeau indéfiniment : tout écart hors fenêtre vaut non-refus.
export function dismissedRecently(raw, now = Date.now()) {
  const at = Number(raw)
  if (!at) return false

  const age = now - at
  return age >= 0 && age < DISMISS_TTL
}

// Les conditions d'affichage, toutes décidables de façon synchrone. Le shell Hotwire
// Native est un Android comme un autre pour l'UA sniffing : le composant ne s'y
// rend pas (Current.hotwire_native_app?), mais la détection ne coûte rien et
// couvre le cas d'un HTML servi depuis un cache rempli par un navigateur.
export function eligiblePlatform({ userAgent, standalone, dismissedAt, now = Date.now() }) {
  if (!/Android/i.test(userAgent)) return false
  if (userAgent.includes("OddScore")) return false
  if (standalone) return false
  if (dismissedRecently(dismissedAt, now)) return false

  return true
}
